import _ from "lodash";
import axios from "axios";

import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import generateQuery from "helpers/query";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_RECEIPTS_RETURNS_REQUEST: "GET_RECEIPTS_RETURNS_REQUEST",
  GET_RECEIPTS_RETURNS_SUCCESS: "GET_RECEIPTS_RETURNS_SUCCESS",
  GET_RECEIPTS_RETURNS_FAILURE: "GET_RECEIPTS_RETURNS_FAILURE"
};

export default class Actions {
  public static getReceipts(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "receiptsReturns.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(
            savedSettings,
            `${CUSTOM_SETTINGS.receiptsReturns}.pageSize`,
            10
          )
        );
      }

      const url = `ReceiptsAndReturnsExtended?$expand=OtherRelation,Supplier,Seller,Order
        &$select=Id,DocumentId,ReceiptId,RoleId,Date,ReceiptDate,OtherRelation/Name,
        OtherRelation/Number,Seller/Name,Seller/Number,Supplier/Name,
        Supplier/Number,Order/Number,OrderId,Read
        ${generateQuery(meta, "RelationId")}`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0)
        };
        dispatch(success(payload, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_RECEIPTS_RETURNS_REQUEST };
    }
    function success(payload, meta) {
      return {
        type: actionTypes.GET_RECEIPTS_RETURNS_SUCCESS,
        payload,
        meta
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_RECEIPTS_RETURNS_FAILURE, error };
    }
  }
}
